import { useIntl } from 'react-intl'

import { useSnackbar } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'
import { logError } from '@subaio/utils'

import type { Asset } from 'apiTypes/Asset'
import { AssetAddedBy } from 'apiTypes/AssetAddedBy'

import { Card } from 'components/Layout'

import type { Step, StepType } from '../../Step'
import type { StepHandlers } from '../../stepHandler'
import { AssetsForm } from './AssetsForm'

type Model = {
	assets: Array<Asset>
}

type Props = TaggedType<Step, StepType.Assets> & {
	assets: Array<Asset>

	onNext: StepHandlers['onAssetsFinish']
	onSaveAssets: (assets: Array<Asset>) => Promise<void>
}

export const Assets = ({ assets, onNext, onSaveAssets }: Props) => {
	const { formatMessage } = useIntl()
	const { showSnackbar } = useSnackbar()
	const hasAdvisorPrefilledAssets = assets.some(({ addedBy }) => addedBy === AssetAddedBy.Advisor)

	return (
		<Card>
			<Form<Model>
				initialValues={{ assets }}
				render={() => <AssetsForm hasAdvisorPrefilledAssets={hasAdvisorPrefilledAssets} />}
				onSubmit={async ({ assets }) => {
					try {
						if (assets.length > 0) {
							await onSaveAssets(assets)
						}
						await onNext()
					} catch (error) {
						logError(error)
						showSnackbar({
							message: formatMessage({
								id: 'flow.assets.saveError',
								defaultMessage: 'We could not save your assets',
							}),
						})
					}
				}}
			/>
		</Card>
	)
}
